import React from "react";
import { useInView } from "react-intersection-observer";

const MobOverlapQuote = ({quote}) => {
    const { ref: upperLineRef, inView: upperLineInView } = useInView({
        triggerOnce: true,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0,
    });

    const { ref: lowerLineRef, inView: lowerLineInView } = useInView({
        triggerOnce: true,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0,
    });

    return(
        <>
            <div
                style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignContent: "space-between",
                    top: 0,
                    fontSize: "13vw",
                    fontFamily: "var(--font-bold)",
                    fontWeight: "800",
                    fontStretch: "extra-condensed",
                    lineHeight: 0.8,
                    whiteSpace: "nowrap"
                }}
            >
                <span 
                    style={{
                        display: "inline-block",
                        transform: "translateY(calc(-100% - 2dvh))",
                        fontSize: "18vw",
                        textAlign: "right",
                        overflow: "hidden"
                    }}
                >
                    <span 
                        style={{
                            display: "inline-block",
                            transform: "translate3d(0, 100%, 0)",
                            opacity: 0,
                            whiteSpace: "wrap",
                            lineHeight: 1,
                            paddingRight: "10px"
                        }}
                        className={`${upperLineInView ? 'titleLineIn' : ''}`} 
                        ref={upperLineRef}
                    >{quote[0]}</span>
                </span>
                <span 
                    className="hollow-text"
                    style={{
                        display: "inline-block",
                        transform: "translateY(calc(100% + 2dvh))",
                        textAlign: "left",
                        overflow: "hidden"
                    }}
                >
                    <span 
                        style={{
                            display: "inline-block",
                            transform: "translate3d(0, 100%, 0)",
                            opacity: 0,
                            fontSize: quote[1].length > 23 ? "11.5vw" : quote[1].length > 22 ? "12.5vw" :quote[1].length > 19 ? "15vw" : null,
                            whiteSpace: "wrap",
                            lineHeight: 1,
                            paddingLeft: "10px"
                        }}
                        className={`${lowerLineInView ? 'titleLineIn' : ''}`} 
                        ref={lowerLineRef}
                    >{quote[1]}</span>
                </span>
            </div>
        </>
    )
}

export default MobOverlapQuote;